/* import __COLOCATED_TEMPLATE__ from './notifications-ask-modal.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class NotificationsAskModal extends Component {
  @service modalService;
  @action
  closeModal() {
    this.modalService.closeModal();
  }
}
